export default {
  components: {
    appUpdateBanner: {
      message: "Une nouvelle version de Jasper est disponible.",
      updateButton: "Mettre à jour",
    },
  },
};
